import { Link } from "react-router-dom";
import bgcorp from "../assets/images/greenbgcorp.png";
import growth from "../assets/images/bggrowth.png";
import hero from "../assets/images/hero2.jpg"
import construction from "../assets/images/construction.png";
import technology from "../assets/images/technology.png";
import healthcare from "../assets/images/healthcare.png";
import manufacturing from "../assets/images/manufacturing.png";
import { FaYoutube } from "react-icons/fa";
import { FaDollarSign, FaUserTie } from "react-icons/fa";
import abhi from "../assets/images/abhi.jpeg"
import grow from "../assets/images/grow.png";
import { FaLinkedinIn, FaXTwitter } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import shield from "../assets/images/shield1.png"
import { motion } from "framer-motion";

const HomePage = () => {
  const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};
  return ( 
    <div
      data-testid="home-page"
      style={{
        width: "100%",
        minHeight: "100vh",
        marginTop:"-80px",
        background: "#EFEFF2",
        fontFamily: "Inter, sans-serif",
        // overflowX: "hidden",
        position: "relative",
      }}
    >
      <motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
      {/* HERO SECTION */}
      <div className="relative text-center" style={{ paddingTop: "88px" }}>
<div
  style={{
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "624px",
    backgroundImage: `linear-gradient(to bottom, rgba(255,255,255,1) 10%, rgba(255,255,255,0) 60%), url(${hero})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    zIndex: 0,
    opacity:0.6,
    pointerEvents: "none",
  }}
/>

        <div style={{ position: "relative", zIndex: 1 }}>
          <h1
            style={{
              fontSize: "48px",
              color: "#696C72",
              maxWidth: "589px",
              margin: "0 auto",
              lineHeight: "1.25",
            }}
          >
            <span style={{ fontWeight: "700" }}>
              Empowering Corporates
            </span>{" "}
            with
            <br />
            Clarity & Confidence.
          </h1>

          <p
            style={{
              fontSize: "17px",
              color: "#66686C",
              maxWidth: "437px",
              margin: "24px auto 0",
            }}
          >
            Tailored Insurance & Loan Solutions for Growth.
          </p>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: "7px",
              marginTop: "32px",
            }}
          >
            <Link
              to="/blogs"
              style={{
                fontSize: "12px",
                color: "#70c037",
                background: "#FCFCFC",
                borderRadius: "16px",
                border: "1px solid #D1D1D6",
                padding: "9px 30px",
              }}
            >
              Check Our Insights
            </Link>

            <Link
              to="/about"
              style={{
                fontSize: "12px",
                fontWeight: "700",
                color: "#fff",
                background: "#70c037",
                borderRadius: "16px",
                border: "1px solid #a1c388",
                padding: "9px 32px",
              }}
            >
              Learn More
            </Link>
          </div>
        </div>
      </div>
</motion.section>
      {/* SERVICE CARDS */}
<div
  style={{
    maxWidth: "1024px",
    margin: "120px auto 0",
    display: "flex",
    gap: "24px",
    paddingLeft: "20px",
    paddingRight: "20px",
    position: "relative",
    zIndex: 2,
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "stretch", // ✅ FIX 1
  }}
>

  {/* Corporate Insurance */}
  <motion.div
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    style={{ flex: "1 1 420px", display: "flex" }} // ✅ FIX 2
  >
    <div
      style={{
        flex: 1,
        maxWidth: "463px",
        padding: "26px 36px",
        borderRadius: "10px",
        background: `
          radial-gradient(circle at bottom right, rgba(112,192,55,0.25), transparent 55%),
          #F5F6F8
        `,
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        display: "flex",                  // ✅ FIX 3
        flexDirection: "column",          // ✅
        justifyContent: "space-between",  // ✅
      }}
    >
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "10px" }}>
          <img
            src={bgcorp}
            alt="Corporate Insurance"
            style={{ width: "70px", height: "70px", objectFit: "contain" }}
          />

          <h3 style={{ fontSize: "22px", fontWeight: "600", color: "#70c037", margin: 0 }}>
            Corporate Insurance
          </h3>
        </div>

        <p style={{ fontSize: "18px", color: "#616266", marginBottom: "6px" }}>
          Risk Managed. Future Secured.
        </p>

        <p style={{ fontSize: "14px", color: "#86878C", marginBottom: "20px" }}>
          Comprehensive coverage tailored for your business.
        </p>
      </div>

<Link
  to="/insurance"
  style={{
    display: "flex",              // ✅ changed
    width: "100%",                // ✅ full width
    justifyContent: "center",     // ✅ center text
    padding: "12px 28px",
    borderRadius: "40px",
    border: "1px solid #DFE1E5",
    background: "#FCFCFD",
    fontWeight: "600",
    color: "#606268",
    textDecoration: "none",
  }}
>
  Explore Insurance Plans
</Link>
    </div>
  </motion.div>

  {/* Corporate Loans */}
  <motion.div
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
    style={{ flex: "1 1 420px", display: "flex" }} // ✅ FIX 2
  >
    <div
      style={{
        flex: 1,
        maxWidth: "463px",
        padding: "26px 36px",
        borderRadius: "10px",
        background: `
          radial-gradient(circle at bottom right, rgba(112,192,55,0.25), transparent 55%),
          #F5F6F8
        `,
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
        display: "flex",                  // ✅ FIX 3
        flexDirection: "column",          // ✅
        justifyContent: "space-between",  // ✅
      }}
    >
      <div>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "10px" }}>
          <img
            src={growth}
            alt="Corporate Loans"
            style={{ width: "70px", height: "70px", objectFit: "contain" }}
          />

          <h3 style={{ fontSize: "22px", fontWeight: "600", color: "#70c037", margin: 0 }}>
            Corporate Loans
          </h3>
        </div>

        <p style={{ fontSize: "18px", color: "#616266", marginBottom: "6px" }}>
          Capital That Works for You.
        </p>

        <p style={{ fontSize: "14px", color: "#86878C", marginBottom: "20px" }}>
          Flexible financing to fuel your growth.
        </p>
      </div>

<Link
  to="/loans"
  style={{
    display: "flex",              // ✅ changed
    width: "100%",                // ✅ full width
    justifyContent: "center",     // ✅ center text
    padding: "12px 28px",
    borderRadius: "40px",
    border: "1px solid #DFE1E5",
    background: "#FCFCFD",
    fontWeight: "600",
    color: "#606268",
    textDecoration: "none",
  }}
>
   Explore Loan Options
</Link>
    </div>
  </motion.div>

</div>

      {/* FEATURES */}
<div style={{ marginTop: "80px", padding: "0 20px" }}>

  {/* Top Divider */}
  <div
    style={{
      margin: "0 auto",
      maxWidth: "920px",
      width: "100%",
      height: "2px",
      background: "#70c037",
    }}
  />

  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      marginTop: "40px",
      maxWidth: "1024px",
      marginLeft: "auto",
      marginRight: "auto",
      alignItems: "center",
    }}
  ><motion.div
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
  style={{
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
  }}
>

  {/* Left Feature */}
  <div
    style={{
      flex: "1 1 500px",
      textAlign: "center",
      padding: "20px",
    }}
  >
    <h2 style={{ fontSize: "24px", fontWeight: "700", color: "#444851" }}>
      Protect Your Business
    </h2>

    <p style={{ color: "#8C8F94", marginBottom: "20px" }}>
      Safeguard your assets with confidence.
    </p>

    <img
      src={shield}
      alt="Protect Business"
      style={{ width: "100%", maxWidth: "550px" }}
    />
  </div>

  {/* Divider */}
  {/* Divider */}
<div
  style={{
    background: "#E4E6EB",
    margin: "20px 0",

    // Desktop styles
    width: "2px",
    minHeight: "300px",

    // Mobile override using media query
  }}
  className="responsive-divider"
/>

  {/* Right Feature */}
  <div
    style={{
      flex: "1 1 500px",
      textAlign: "center",
      padding: "20px",
    }}
  >
    <h2 style={{ fontSize: "24px", fontWeight: "700", color: "#444851" }}>
      Fuel Your Expansion
    </h2>

    <p style={{ color: "#8C8F94", marginBottom: "20px" }}>
      Empower your growth ambitions
    </p>

    <img
      src={grow}
      alt="Business Growth"
      style={{ width: "100%", maxWidth: "550px" }}
    />
  </div>

</motion.div>
</div>
</div>


<section className="">
  <motion.div
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true }}
  >
    <div className="max-w-5xl mx-auto px-6">

      {/* Single Card */}
      <div
  className="shadow-md rounded-2xl px-8 py-8 border-t-4 border-[#70c037]"
  style={{
    background: `
      radial-gradient(circle at bottom right, rgba(112,192,55,0.25), transparent 55%),
      #F5F6F8
    `,
  }}
>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between text-left gap-8 md:gap-0">

          {/* Item 1 */}
          <div className="flex items-center gap-4">
            <h2 className="text-4xl font-semibold text-[#70c037]">2</h2>
            <div>
              <p className="text-gray-700 font-medium">Years of</p>
              <p className="text-gray-700">Excellence</p>
            </div>
          </div>

          {/* Divider */}
          <div className="hidden md:block h-12 w-px bg-gray-200"></div>

          {/* Item 2 */}
          <div className="flex items-center gap-4">
            <div className="text-[#70c037] text-3xl">
              <FaDollarSign />
            </div>
            <div>
              <p className="text-lg font-semibold text-gray-700">
                Worked with
              </p>
              <p className="text-gray-700">
                Multi billion dollar companies
              </p>
            </div>
          </div>

          {/* Divider */}
          <div className="hidden md:block h-12 w-px bg-gray-200"></div>

          {/* Item 3 */}
          <div className="flex items-center gap-4">
            <div className="text-[#70c037] text-3xl">
              <FaUserTie />
            </div>
            <div>
              <p className="text-lg font-semibold text-gray-900">
                Trusted by
              </p>
              <p className="text-gray-600">
                Industry Leaders
              </p>
            </div>
          </div>

        </div>

      </div>

    </div>
  </motion.div>
</section>


      {/* CONNECT SECTION */}
<div style={{ marginTop: "50px", textAlign: "center", padding: "0 20px" }}>
  <motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
  {/* Heading with Lines */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "12px",
      marginBottom: "10px",
      flexWrap: "wrap",
    }}
  >
    <div
      style={{
        height: "1px",
        background: "#70c037",
        flex: 1,
        maxWidth: "180px",
      }}
    />

    <h2
      style={{
        fontSize: "24px",
        color: "#3E434C",
        margin: 0,
      }}
    >
      Stay Connected
    </h2>

    <div
      style={{
        height: "1px",
        background: "#70c037",
        flex: 1,
        maxWidth: "180px",
      }}
    />
  </div>

  {/* Description */}
  <p style={{ color: "#7A7D82", marginTop: "10px", fontSize: "14px" }}>
    Follow us for the latest updates and insights:
  </p>

  {/* Social Icons */}
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      marginTop: "20px",
    }}
  >
    <div
      style={{
        display: "flex",
        gap: "18px",
        fontSize: "26px",
        color: "#70c037",
        flexWrap: "wrap",
        justifyContent: "center",
      }}
    >
      <a href="https://www.linkedin.com/in/abhimandagiri/" target="_blank">
        <FaLinkedinIn />
      </a>

      <a href="https://www.youtube.com/@AbhiMandagiri" target="_blank">
        <FaYoutube />
      </a>

      <a href="mailto:sunoji@abhifs.com">
        <MdEmail />
      </a>
    </div>
  </div>
  </motion.section>

  {/* CTA Button */}
  <motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
  <Link to="/contact" >
  <button
    style={{
      marginTop: "24px",
      background: "#70c037",
      color: "white",
      padding: "12px 28px",
      borderRadius: "6px",
      border: "none",
      fontWeight: "600",
      boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
      cursor: "pointer",
      maxWidth: "280px",
      width: "100%",
    }}
  >
    📅 Book a Consultation
  </button>
  </Link>
</motion.section>
</div>

{/* INDUSTRY SECTION */}
<div style={{ marginTop: "80px", textAlign: "center", padding: "0 20px" }}>
<motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
{/* Heading */}
<div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "12px",
    marginTop: "40px",
    marginBottom: "10px",
    flexWrap: "wrap",
  }}
>
  <div
    style={{
      height: "1px",
      background: "#70c037",
      flex: 1,
      maxWidth: "220px",
    }}
  />

  <h2 style={{ fontSize: "22px", color: "#3E434C", margin: 0 }}>
    Trusted by Industry Leaders
  </h2>

  <div
    style={{
      height: "1px",
      background: "#70c037",
      flex: 1,
      maxWidth: "220px",
    }}
  />
</div>

<p style={{ color: "#7A7D82", marginTop: "10px", fontSize: "14px" }}>
  From billion dollar corporations to innovative startups, we're here to
  support your success.
</p>
</motion.section>

<motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
{/* Industry Cards */}
<div
  style={{
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "20px",
    marginTop: "40px",
  }}
>
  {[
    { name: "Construction", img: construction },
    { name: "Technology", img: technology },
    { name: "Healthcare", img: healthcare },
    { name: "Manufacturing", img: manufacturing },
  ].map((item) => (
    <div
      key={item.name}
      style={{
        flex: "1 1 200px",
        maxWidth: "220px",
        borderRadius: "8px",
        overflow: "hidden",
        background: "#F5F6F8",
        boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
      }}
    >
      {/* Image */}
      <div
        style={{
          height: "110px",
          backgroundImage: `url(${item.img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      {/* Text */}
      <div style={{ padding: "15px", textAlign: "center" }}>
        <p style={{ fontWeight: "600", color: "#444851", margin: 0 }}>
          {item.name}
        </p>
      </div>
    </div>
  ))}
</div>
</motion.section>


<motion.section
  variants={fadeUp}
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
>
{/* Founder Section */}
<div
  style={{
    maxWidth: "1024px",
    margin: "80px auto",
    background: "#F5F6F8",
    padding: "15px",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
    display: "flex",
    flexWrap: "wrap",
    gap: "20px",
    alignItems: "center",
    justifyContent: "center"
  }}
>
<img
  src={abhi}
  alt="Founder"
  style={{
    width: "140px",
    height: "140px",
    borderRadius: "8px",
    objectFit: "cover",
    margin: "0 auto",
    display: "block"
  }}
/>

<div style={{ flex: "1 1 300px", textAlign: "left" }}>
  <h3 style={{ margin: 0, color: "#3E434C" }}>Abhishek M</h3>

  <p style={{ marginTop: "5px", color: "#6A6D72", fontWeight: "500" }}>
    Founder & Financial Consultant
  </p>

  <p style={{ marginTop: "12px", color: "#70c037" }}>
    <b>Global Experience, Personal Commitment.</b>
  </p>

  <p style={{ marginTop: "5px", color: "#6E7176", fontSize: "14px" }}>
    With global boardroom experience and a passion for clarity, I’m here to help you navigate insurance and funding with confidence.{" "}
    
    <Link
      to="/about"
      style={{
        color: "#70c037",
        fontWeight: "600",
        textDecoration: "none",
      }}
    >
      Read More →
    </Link>
  </p>
</div>
</div>
</motion.section>
</div>
</div>
  );
};

export default HomePage;